var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayerOpponent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 78.97 78.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .d-own {\n        fill: url(#c);\n      }\n\n      .e-own {\n        mix-blend-mode: soft-light;\n      }\n\n      .f-own {\n        isolation: isolate;\n      }\n\n      .g-own {\n        fill: url(#b);\n      }\n\n      .h-own {\n        fill: #4183c4;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 19.74,
    y1: 5.28,
    x2: 59.23,
    y2: 73.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 39.48,
    y1: 71.93,
    x2: 39.48,
    y2: 7.03,
    xlinkHref: "#b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "f-own"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "h-own",
    cx: 39.48,
    cy: 39.48,
    r: 39.48
  }), /*#__PURE__*/React.createElement("g", {
    className: "e-own"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g-own",
    d: "M39.48,7c17.91,0,32.48,14.57,32.48,32.48s-14.57,32.48-32.48,32.48S7,57.39,7,39.48,21.57,7,39.48,7M39.48,0C17.68,0,0,17.68,0,39.48s17.68,39.48,39.48,39.48,39.48-17.68,39.48-39.48S61.29,0,39.48,0h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e-own"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d-own",
    d: "M39.48,8.03c17.34,0,31.45,14.11,31.45,31.45s-14.11,31.45-31.45,31.45-31.45-14.11-31.45-31.45,14.11-31.45,31.45-31.45M39.48,7.03C21.56,7.03,7.03,21.56,7.03,39.48s14.53,32.45,32.45,32.45,32.45-14.53,32.45-32.45S57.41,7.03,39.48,7.03h0Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerOpponent);
export default __webpack_public_path__ + "static/media/player-opponent.027dceed571010e5d3a2c8162ea24290.svg";
export { ForwardRef as ReactComponent };